import styled from 'styled-components';

const StyledNotificationDot = styled.div`
  // needed to inherit the font styles from TableTabList
  font-family: inherit;
  display: flex;
  gap: 2px;
  align-items: flex-start;
  // we never want the StatusDot to appear on its own line
  flex-wrap: nowrap;
`;

const StatusText = styled.span`
  // needed to inherit the font styles from TableTabList
  font-family: inherit;
  white-space: nowrap;
`;

const StatusDot = styled.span`
  // min-width is required because the parent has flex
  min-width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--red-400);
  vertical-align: middle;
`;

export type NotificationDotProps = {
  /**
   * Text that is visually hidden but read aloud by screen readers to describe the number. This should be a description of the thing the number represents, like "open PA reviews" or "tasks requiring response".
   */
  srOnlyText?: string;
  children: React.ReactNode;
};

/**
 * A small, circular-ish badge that appears to the top right of the child element and indicates there are items that need attention from the user.
 */
const NotificationDot = ({ srOnlyText, children }: NotificationDotProps) => {
  return (
    <StyledNotificationDot>
      {srOnlyText && <span className="sr-only">{srOnlyText}</span>}
      <StatusText>{children}</StatusText>
      <StatusDot />
    </StyledNotificationDot>
  );
};

export default NotificationDot;
